import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-a3018d18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "operate-system-wrap cm-form-info-grid" }
const _hoisted_2 = { class: "cm-form-item" }
const _hoisted_3 = { class: "cm-form-item" }
const _hoisted_4 = { class: "cm-form-item" }
const _hoisted_5 = { class: "cm-form-item" }
const _hoisted_6 = { class: "cm-form-item" }
const _hoisted_7 = { class: "cm-form-item" }
const _hoisted_8 = { class: "cm-form-item" }
const _hoisted_9 = { class: "cm-form-item" }
const _hoisted_10 = { class: "cm-form-item" }
const _hoisted_11 = {
  key: 0,
  class: "cm-form-item"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "系统升级包", -1))
const _hoisted_13 = { class: "cm-form-item" }
const _hoisted_14 = { class: "cm-form-item" }
const _hoisted_15 = { class: "cm-form-item" }
const _hoisted_16 = { class: "cm-form-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.osSystemName')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.compData.system_name || '--'), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.osInstallDate')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.formatTimeStamp(_ctx.compData.install_time)), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.osActivationStatus')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.compData.state_activation === 1 ? _ctx.$t('groupClient.terminalInfoDetail.osActivated') : _ctx.$t('groupClient.terminalInfoDetail.osNotActivated')), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.osProductKey')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.compData.product_key || '--'), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.osRegisteredUser')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.compData.registered_user || '--'), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.osRegisteredOrg')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.compData.registered_organization || '--'), 1)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.osLicensedProcessors')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.compData.processors_count), 1)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.osProductId')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.compData.product_id || '--'), 1)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.osSystemType')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.compData.architecture || '--'), 1)
    ]),
    (0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("span", null, _toDisplayString(_ctx.compData.update_package || '--'), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.osCodeName')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.compData.code_set || '--'), 1)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.osSystemVersion')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.compData.system_version || '--'), 1)
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.osSystemLanguage')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.compData.language || '--'), 1)
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.osBuildType')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.compData.build_type || '--'), 1)
    ])
  ])), [
    [_directive_loading, _ctx.isLoading]
  ])
}